import { Box } from '@factorialco/deprecated-design-system'

import VideoPlayer from 'modules/trainings/components/VideoPlayer'
import { ContentViewProps } from 'modules/trainings/components/content/types'
import { VideoBlock } from 'modules/trainings/lib/content/VideoBlock'

export const VideoBlockConsumer = ({ contentItem }: ContentViewProps<VideoBlock>) => {
  return (
    <>
      <h2 className="text-3xl font-semibold f1-foreground">{contentItem.title}</h2>
      {contentItem.video.url && (
        <Box
          style={{
            borderRadius: '1rem',
            overflow: 'hidden',
            aspectRatio: '16 / 9',
            backgroundColor: '#000',
          }}
        >
          <VideoPlayer
            src={contentItem.video.url}
            onPercentageWatchedMilestone={(milestone) => {
              if (milestone === 100) {
                // TODO: Add this to the class and load it in the mapper
                // contentItem.completed = true
              }
            }}
          />
        </Box>
      )}
    </>
  )
}
